module.exports = __webpack_public_path__ + "511336eb9f6f334f0faf456fa8e11858.svg";